var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#006699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3989 28.1054V17.3002H11.8106V28.1054H15.3993H15.3989ZM13.6055 15.8252C14.8566 15.8252 15.6354 14.9955 15.6354 13.9586C15.612 12.8981 14.8566 12.0916 13.6293 12.0916C12.4012 12.0916 11.5991 12.8981 11.5991 13.9585C11.5991 14.9954 12.3777 15.8251 13.582 15.8251H13.6052L13.6055 15.8252ZM17.3851 28.1054H20.9731V22.072C20.9731 21.7495 20.9965 21.4261 21.0913 21.1958C21.3505 20.5503 21.9409 19.8821 22.9324 19.8821C24.2305 19.8821 24.7501 20.8729 24.7501 22.3256V28.1054H28.338V21.9101C28.338 18.5913 26.568 17.0469 24.2073 17.0469C22.2718 17.0469 21.4217 18.1297 20.9495 18.8671H20.9733V17.3006H17.3853C17.4321 18.3143 17.385 28.1058 17.385 28.1058L17.3851 28.1054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.71e6b6f397000ba33ae22111dcb49be2.svg";
export { ForwardRef as ReactComponent };